export default __webpack_public_path__ + "static/media/marvel image.55e5b674.webp";